import { trans } from "@mongez/localization";
import { ShopProduct } from "core/catalog";
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { SwiperSlide } from "swiper/react";
import { ProductsSection, ProductsSlider } from "~/modules/home/components";
import { ProductCard } from "~/modules/our-cakes/components";
import { useFetch } from "~/shared/hooks";
import { URLS } from "~/shared/urls";
import { ProductsLoader } from "./ProductsLoader";

type RelatedProductsProps = {
  productId: number;
};

type RelatedProductsResponse = {
  relatedProducts: ShopProduct[];
};

export function RelatedProducts({ productId }: RelatedProductsProps) {
  const { ref, inView } = useInView({
    triggerOnce: true,
  });
  const { data, load, isLoading } = useFetch<RelatedProductsResponse>(
    URLS.ourCakes.relatedProducts(productId),
  );

  useEffect(() => {
    if (inView) {
      load();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productId, inView]);

  if (isLoading) {
    return <ProductsLoader />;
  }

  return (
    <div ref={ref} className="relative">
      {data?.relatedProducts && data?.relatedProducts.length > 0 ? (
        <ProductsSection
          title={{
            top: trans("relatedProducts"),
          }}
          className="bg-[#FFF1F3]/50"
          classes={{
            container: "gap-6 md:gap-10",
            title: {
              top: "capitalize text-3xl md:text-5xl",
            },
          }}
        >
          <ProductsSlider>
            {data?.relatedProducts.map((product) => (
              <SwiperSlide key={product.id} className="h-full w-full">
                <ProductCard product={product} />
              </SwiperSlide>
            ))}
          </ProductsSlider>
        </ProductsSection>
      ) : null}
    </div>
  );
}
